import React from 'react';

import './SellAddressReview.scss';

import If from '../../Shared/If/If';
import { Address } from '../MailACheck/Address';

const SellAddressReview = ({ address, name }) => (
  <div className="sell-address-review">
    <div className="sell-address-review-delivery-method"> MAIL CHECK TO </div>
    <div className="sell-address-review-fund-user-name">
      <span className="blocked_data">{name}</span>
    </div>
    <If test={address}>
      <div className="sell-address-review-fund-address">
        <Address address={address} />
      </div>
    </If>
    {/** Typically I would remove entirely, but it has been discussed this might be coming back in a future story
     that incorporates the modal experience
    <div className="hidden-xs hidden-sm"
         styleName="check-details">
      <img alt=""
           src='assets/images/check-icon_minus_sign.svg'/>
      <a> View Check Details </a>
    </div>
     */}
  </div>
);

export default SellAddressReview;
